export const arePrimitiveArraysEqual = <T>(
  array1: T[],
  array2: T[],
): boolean => {
  return [...array1].sort().toString() === [...array2].sort().toString();
};
